<template>
    <form>
        <div class="form-row">
            <div class="col-8">
                <label for="subject">Vorgang</label>
                <input
                    v-model="t_text"
                    type="text"
                    class="form-control"
                    id="subject"
                    placeholder="Vorgang"
                    title="Kurzer Text, der die Buchung beschreibt"
                    @keydown.enter.prevent
                >
            </div>
            <div class="col">
                <label for="receipt-id">Kassenanordnungsnummer</label>
                <input
                    v-model="t_receiptInfo"
                    type="text"
                    class="form-control"
                    id="receipt-id"
                    placeholder="Kassenanordnungsnummer"
                    autocomplete="off"
                    title="Identifikationsnummer der entsprechenden Kassenanordnung"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <!--<div class="col-4">
                <label for="counter_acc">Kostenstelle</label>
                <select
                    v-model="t_counterAcc"
                    class="custom-select"
                    title="Kostenstelle bzw. Gegenkonto dieser Buchung"
                    id="counter_acc">
                    <option value=0 selected>Kostenstelle auswählen...</option>
                    <option v-for="item_name in account_list" :key="item_name" :value="item_name">
                        {{ item_name }}
                    </option>
                    
                </select>
            </div>-->
            <div class="col">
                <label for="entryDate" title="Wann ist die Buchung erfolgt?">Datum</label>
                <datepicker
                    format="yyyy-MM-dd"
                    v-model="t_date"
                    input-class="form-control"
                    :language="de"
                    :monday-first=true
                    id="entryDate"
                    :disabled-dates="{from: new Date()}"
                    @keydown.enter.prevent
                >
                </datepicker>
            </div>
            <div class="col">
                <label for="amount">Betrag</label>
                <div class="input-group">
                    <input
                        v-model="t_amount"
                        title="Betrag in EUR, nur postive Werte eintragen"
                        type="number"
                        lang="de"
                        step="0.01"
                        min="0"
                        class="form-control"
                        id="amount"
                        placeholder="0,00"
                        @keydown.enter.prevent
                    />
                    <div class="input-group-append">
                        <span class="input-group-text">€</span>
                    </div>
                </div>
            </div>
            <div class="col">
                <label for="files">Belegupload</label>
                <input
                    class="form-control-file"
                    type="file" id="files" ref="files" multiple
                    accept=".pdf, .jpg, .jpeg, .png"
                    v-on:change="handleFileUpload()"
                />
            </div>
        </div>
            <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('INPUT', $event)" v-on:submit.prevent="onSubmit" class="btn btn-success" href="#" role="button">
                    Einnahme buchen
                </a>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <button v-on:click="perform('OUTPUT', $event)" v-on:submit.prevent="onSubmit" class="btn btn-danger">
                    Ausgabe buchen
                </button>
            </div>
        </div>
        
    </form>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'BookEntry',
    components: {
        Datepicker
    },
    data() {
        return {
            account: 'Default',
            error_msg: 'No Error',
            t_text: '',
            t_receiptInfo: '',
            t_counterAcc: '',
            t_amount: '',
            t_date: '',
            t_files: null,
            en: en,
            de: de,
            account_list: [
            //Einnahmen
                this.accountName + "_EXPENSE"
            ]
        }
    },
    methods: {
        handleFileUpload() {
            // check if one of files is PDF and if the number of files is greater than 1, show error
            if (this.$refs.files.files.length > 1) {
                for (let i = 0; i < this.$refs.files.files.length; i++) {
                    if (this.$refs.files.files[i].type === "application/pdf") {
                        this.$refs.files.value = null
                        this.t_files = null
                        let msg = {
                            message: "Merfachauswahl ist nur für Bilder erlaubt",
                            type: "ERROR"
                        }
                        this.$store.commit('add_message', msg)
                        return
                    }
                }
            }
            if (this.$refs.files.files.length > 10) {
                this.$refs.files.value = null
                this.t_files = null
                let msg = {
                    message: "Maximal 10 Dateien erlaubt",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
                return
            }
            this.t_files = this.$refs.files.files;
        },
        perform(actionType, event) {
            event.preventDefault();
            var msg = null
            if (this.t_text == "") {
                msg = {
                    message: "Kein Vorgang eingetragen",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (this.t_receiptInfo == "") {
                msg = {
                    message: "Keine Kassenanordnungsnummer eingetragen",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (this.t_amount == "") {
                msg = {
                    message: "Kein Betrag eingetragen",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (this.t_files === null) {
                msg = {
                    message: "Kein Beleg zum Upload ausgewählt",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (msg !== null) {
                return
            }
            let actionTypeText = "Ausgabe";
            if (actionType === "INPUT") {
                actionTypeText = "Einnahme";
            }
            if (!confirm(actionTypeText + ' bestätigen?')) {
                return;
            }
            const data = new FormData();
            data.append('accName', this.accountName)
            data.append('receiptInfo', this.t_receiptInfo)
            data.append('text', this.t_text)
            data.append('amount', this.t_amount)
            let dateStr = "";
            if (this.t_date) {
                dateStr = this.$filters.formatDate(this.t_date.toISOString());
            }
            data.append('date', dateStr)
            data.append('actionType', actionType)
            for (let i = 0; i < this.t_files.length; i++) {
                let file = this.t_files[i];
                data.append('file' + i, file);
            }
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: process.env.VUE_APP_ROOT_API
                    + '/account/'
                    + this.accountName
                    + '/entries',
                data: data,
                auth: credentials,
                method: 'post'
            })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                })
                .then(resp => {
                    msg = resp.data
                    if (!(msg.type == "NONE")) {
                        // eslint-disable-next-line
                        console.log("Pushing error")
                        this.$store.commit('add_message', msg)
                    }
                    this.$store.dispatch('loadCurrentAccount');
                    this.$store.dispatch('loadAccounts');
                });
            this.t_text = ''
            this.t_receiptInfo = ''
            this.t_counterAcc = ''
            this.t_amount = ''
            this.t_date = ''
            this.t_files = null
            this.$refs.files.value = null

        }
    },
    computed: {
        accountName () {
            return this.$store.state.current_acc
        },
    }
}
</script>

<style scoped>

</style>

